module.exports = __webpack_public_path__ + "img/banner-26.e33694c4.jpg";